import { Option } from "shared/components/forms/Select";
import { Crumb } from "shared/components/BreadCrumbs";

export const RENT_REPORTING_SETTINGS_CRUMBS: Crumb[] = [
  {
    title: "Rent reporting",
    href: "/rent-reporting"
  },
  {
    title: "Enrollment settings",
    href: "/rent-reporting/settings"
  }
];

export const STATE_ENROLLMENT_TYPE_OPTIONS: Option[] = [
  { label: "Required", value: "direct" },
  { label: "Renters can opt-in", value: "opt_in" },
  { label: "Renters can opt-out", value: "opt_out" }
];

export const ENROLLMENT_TYPE_OPTIONS: Option[] = [
  { label: "No default", value: "na" },
  ...STATE_ENROLLMENT_TYPE_OPTIONS
];
